import React, { createContext, useMemo } from 'react';
import { ComponentProps } from './HotelInformation.types';
import { Styled } from './HotelInformation.styles';
import { Information } from './Information/index';
import { Amenities } from './Amenities/index';
import { PropertyDetails } from './PropertyDetails/index';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const serverDataProps: any = {
  hotelInformationData: {},
  propertyId: '',
  jsonContent: {},
  amenitiesData: {},
  accessibilityData: {},
  generalInformationData: {},
  brandCode: '',
};

export const serverData = createContext(serverDataProps);

export const HotelInformation: React.FC<ComponentProps> = ({
  hotelInformationData,
  propertyId,
  jsonContent,
  amenitiesData,
  accessibilityData,
  generalInformationData,
  brandCode,
  isAuthorMode,
}) => {
  const value: ComponentProps = useMemo(
    () => ({
      hotelInformationData,
      propertyId,
      jsonContent,
      amenitiesData,
      accessibilityData,
      generalInformationData,
      brandCode,
    }),
    [accessibilityData, amenitiesData, brandCode, generalInformationData, hotelInformationData, jsonContent, propertyId]
  );
  return (
    <serverData.Provider value={value}>
      <Styled className="standard">
        {!jsonContent?.['isHotelInformationSectionDisabled'] && <Information />}
        {!jsonContent?.['isAmenitiesSectionDisabled'] && <Amenities isAuthorMode={isAuthorMode} />}
        {!jsonContent?.['isPropertyDetailsSectionDisabled'] && <PropertyDetails />}
      </Styled>
    </serverData.Provider>
  );
};

export default HotelInformation;
